import { render } from "./DeleteConfirmation.vue?vue&type=template&id=45b5b214"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__